import APIV2Adapter from "@/lib/APIV2Adapter";

export default function (config, inject) {
  inject('apiv2', new APIV2Adapter(config.$axios, config.store));
}